import { render, staticRenderFns } from "./TerritoryLocality.vue?vue&type=template&id=06d811fc&"
import script from "./TerritoryLocality.vue?vue&type=script&lang=ts&"
export * from "./TerritoryLocality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports